var _circle, _path, _path2, _path3, _path4, _circle2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpatialPerceptionSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1767,
    cy: 60.1767,
    r: 29.1767,
    fill: "#FFD100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4724 48.5101C39.2844 46.8896 40.0219 45.471 41.1185 45.3438C42.2151 45.2165 43.2578 46.4286 43.4458 48.0491C43.6337 49.6696 42.8962 51.0883 41.7997 51.2155C40.7031 51.3427 39.6604 50.1305 39.4724 48.5101Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3406 46.3968C47.1526 44.7763 47.8901 43.3577 48.9867 43.2305C50.0833 43.1033 51.1259 44.3154 51.3139 45.9358C51.5019 47.5563 50.7644 48.975 49.6678 49.1022C48.5712 49.2294 47.5286 48.0173 47.3406 46.3968Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0977 6.2915C75.3951 6.66228 78.4303 8.10226 80.1917 10.896",
    stroke: "#B5B1BA",
    strokeWidth: 1.61925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3301 4.88867C79.0453 5.09307 80.7186 5.88691 81.6896 7.42704",
    stroke: "#B5B1BA",
    strokeWidth: 1.61925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.2187,
    cy: 21.7964,
    r: 12.954,
    transform: "rotate(-17.0347 67.2187 21.7964)",
    fill: "#F9FAFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8452 11.5595C72.1088 11.256 72.6015 11.5175 72.4977 11.9059L69.6187 22.6795L64.5336 19.9797L71.8452 11.5595Z",
    fill: "#FA5353"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6538 30.7539C61.55 31.1423 62.0427 31.4038 62.3062 31.1003L69.6179 22.6801L64.5328 19.9802L61.6538 30.7539Z",
    fill: "#B5B1BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpatialPerceptionSkills);
export default __webpack_public_path__ + "static/media/spatial_perception_skills.df463099f588f4d448f59be465148d0a.svg";
export { ForwardRef as ReactComponent };